const styleConfig = {
    style: {
        filterLayout: 'StyleFilterDefaultLayout',
        listLayout: 'StyleListDefaultLayout',
        paginationLayout: 'PaginationDefaultLayout',
        getFunc: 'getStyleList',
        listApiParamSet: {
            ip: 1,
            sp: 10,
        },
        pageRow: 10,
        listFailMsg: '데이터를 불러올 수 없습니다.',
    },
    updateStyle: {
        writeLayouts: ['StyleWriteDefaultLayout'],
        getFunc: 'getStyleList',
        detailApiParamSet: {
        },
        writeFunc: 'updateStyle',
        writeApiParamSet: {
        },
        parsingData: {
            // s_title: 'rs_word',
            es_style: 'es_style',
            es_title: 'es_title',
            es_backcolor: 'es_backcolor',
            es_display: 'es_display',
            es_subject: 'es_subject',
            es_text: 'es_text',
        },
        writeSuccessType: 1,
        writeFailTypes: {
            100: '보내는 값이 잘못 되었습니다.'
        },
        directUrl: '',
        directType: 'back',
        fileUploadFailMsg: '이미지 등록에 실패하였습니다.',
        fileInfo: [
            {
                fileName: 'mainFile',
                fileType: 'styleImg',
                required: false,
            },
        ],
        keyName: 'es_idx',
    },
}
export default {
    methods: {
        returnStyleConfig(type) {
            return styleConfig[type];
        }
    },
    filterConfig: {
        ess: { // 제목
            type: 'query',
            classname: 'searchInput'
        },
        cr:{ // 시작일
            type: 'between',
            classname: 'filterDate'
        },
        gen: { //성별
            type: 'match',
            classname: 'filterGender',
        },
        btm: { //하의
            type: 'match',
            classname: 'filterBottom',
        },
    }
}
